import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { MerchantService } from '../_services/fundraising/merchant.service'

@Injectable()
export class ReverseAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.loggedIn()
      .pipe(map(result => {
        if (result) {
          console.log('You are already logged in, redirecting to home page.');
          this.router.navigate(['/portal/' + this.authService.getHomeRoute()]);
        }
        return !result;
    }));
  }
}

@Injectable()
export class ReverseMerchantAuthGuard implements CanActivate {
  constructor(private merchantService: MerchantService, private router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.merchantService.loggedIn()
      .pipe(map(result => {
        if (result) {
          console.log('You are already logged in, redirecting to home page.');
          this.router.navigate(['/merchant']);
        }
        return !result;
    }));
  }
}
